import { render, staticRenderFns } from "./copyWorkFlow.vue?vue&type=template&id=97558b4a&scoped=true&"
import script from "./copyWorkFlow.vue?vue&type=script&lang=js&"
export * from "./copyWorkFlow.vue?vue&type=script&lang=js&"
import style0 from "./copyWorkFlow.vue?vue&type=style&index=0&id=97558b4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97558b4a",
  null
  
)

export default component.exports